import { isEqual } from 'lodash';
import React, { useContext, useEffect, useMemo } from 'react';
import Loading from '../../common/components/Loading';
import { useStepper } from '../../common/components/StepperContext';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import { FormContext } from '../../common/form/FormContext';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { TYPE_TO_ICON } from '../../common/icons/typeToIcon';
import { RESOURCE_FIELD_NAMES, RESOURCE_TYPE } from '../common/resourceConstants';
import { useGetResourceTypes } from '../hooks/useGetResourceTypes';

export default ({ isHireResource = false }: { isHireResource: boolean }) => {
    const { state, validation } = useContext(FormContext);
    const { activeStep, getStepData, setStepData, setStepCompletion } = useStepper();
    const { resourceTypes, fetchingResourceTypes } = useGetResourceTypes();

    const requiredResTypes = useMemo(() => {
        if (isHireResource && !fetchingResourceTypes) {
            // For hire resource functionality, cast and crew are not required
            return resourceTypes.filter((resType) => ![RESOURCE_TYPE.cast, RESOURCE_TYPE.crew].includes(resType));
        }
        return resourceTypes;
    }, [fetchingResourceTypes]);

    useEffect(() => {
        const currentStepData = getStepData(activeStep);
        if (validation?.isValid && !isEqual(currentStepData, state)) {
            setStepData(activeStep, state);
        }
    }, [state]);

    useEffect(() => {
        if (validation) {
            setStepCompletion(activeStep, validation.isValid);
        }
    }, [validation?.isValid]);

    return (
        <FormContainer>
            <FormItem>
                {fetchingResourceTypes ? (
                    <Loading />
                ) : (
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.buttons}
                        name={RESOURCE_FIELD_NAMES.type}
                        labels={requiredResTypes || []}
                        setIcon={(index: number) => TYPE_TO_ICON?.[requiredResTypes[index]] || TYPE_TO_ICON['Default']}
                    />
                )}
            </FormItem>
        </FormContainer>
    );
};
